/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrderSearch } from '../../models/purchase-order-search';
import { PurchaseOrderSearchResult } from '../../models/purchase-order-search-result';

export interface SearchPurchaseOrders$Params {
  page: number;
  size: number;
  sort?: string;
  order?: string;
      body: PurchaseOrderSearch
}

export function searchPurchaseOrders(http: HttpClient, rootUrl: string, params: SearchPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrderSearchResult>> {
  const rb = new RequestBuilder(rootUrl, searchPurchaseOrders.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('order', params.order, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseOrderSearchResult>;
    })
  );
}

searchPurchaseOrders.PATH = '/puchase-orders/search';
